import React, { useState, useEffect } from "react";
import axios from "axios";

const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const ReportStatementEquity = () => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_REPORT = "api/erpppsu/report/PerubahanModal";

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [filterLastDate, setFilterLastDate] = useState(getTodayDate());

    // Fetch data from the API
    const fetchData = async (URL) => {
        setLoading(true);
        setError(null); // Clear previous errors
        try {
            const response = await axios.get(URL);
            return response.data;
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // Fetch data on component mount or filter change
    useEffect(() => {
        if (filterLastDate) {
            fetchData(`${BASE_URL}${PATH_REPORT}?last_date=${filterLastDate}`).then((responseData) => {
                setData(responseData || []); // Ensure data is an array
            });
        }
    }, []);

    const handleFilter = () => {
        if (filterLastDate) {
            fetchData(`${BASE_URL}${PATH_REPORT}?last_date=${filterLastDate}`).then((responseData) => {
                setData(responseData || []); // Ensure data is an array
            });
        }
    };

    if (error) return <div className="text-red-500">{error}</div>;

    return (
        <div className="p-4">
            <h1 className="text-lg font-bold mb-4">Perubahan Modal</h1>

            <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
                {/* Last Date Input */}
                <div className="mx-1">
                    <label htmlFor="last_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Akhir
                    </label>
                    <input
                        id="last_date"
                        name="last_date"
                        type="date"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        value={filterLastDate}
                        onChange={(e) => setFilterLastDate(e.target.value)}
                    />
                </div>

                {/* Filter Button */}
                <div className="p-3 flex items-end">
                    <button
                        onClick={handleFilter}
                        type="button"
                        className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200"
                    >
                        Filter
                    </button>
                </div>
            </div>

            {/* Display Data */}
            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                data.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="mb-6">
                        <h2 className="text-md font-semibold mb-2">{section.label}</h2>
                        {section.data.map((subSection, subSectionIndex) => (
                            <div key={subSectionIndex} className="mb-4">
                                <h3 className="text-sm font-medium mb-2">{subSection.label}</h3>
                                {subSection.data.length > 0 ? (
                                    <table className="min-w-full border-collapse border border-gray-300">
                                        <thead>
                                            <tr>
                                                <th className="border border-gray-300 px-2 py-1 text-left">Code</th>
                                                <th className="border border-gray-300 px-2 py-1 text-left">Name</th>
                                                <th className="border border-gray-300 px-2 py-1 text-left">Permulaan</th>
                                                <th className="border border-gray-300 px-2 py-1 text-left">Debit</th>
                                                <th className="border border-gray-300 px-2 py-1 text-left">Kredit</th>
                                                <th className="border border-gray-300 px-2 py-1 text-right">Current Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {subSection.data.map((item, itemIndex) => (
                                                <tr key={itemIndex}>
                                                    <td className="border border-gray-300 px-2 py-1">{item.code}</td>
                                                    <td className="border border-gray-300 px-2 py-1">{item.name}</td>                                                    
                                                    <td className="border border-gray-300 px-2 py-1 text-right">{Number(item.balance_before).toLocaleString()}</td>
                                                    <td className="border border-gray-300 px-2 py-1 text-right">{Number(item.sum_debit).toLocaleString()}</td>
                                                    <td className="border border-gray-300 px-2 py-1 text-right">{Number(item.sum_credit).toLocaleString()}</td>
                                                    <td className="border border-gray-300 px-2 py-1 text-right">{Number(item.current_balance).toLocaleString()}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <p className="text-sm text-gray-500">No data available.</p>
                                )}
                            </div>
                        ))}
                    </div>
                ))
            )}
        </div>
    );
};

export default ReportStatementEquity;
